import Colors from '@shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListPlanPriceText = styled.span`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${50 * Screen.widthRatio}px;
`;

export default ChannelListPlanPriceText;
